import React from "react";
import { DataTable, Pagination } from "carbon-components-react";
import { WarningAltFilled32, CheckmarkFilled32 } from "@carbon/icons-react";
const {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader,
} = DataTable;

const CheckoutTable = ({ data }) => {
  const [page, setPage] = React.useState({ current: 1, pageSize: 10 });
  console.log(data);
  const filteredData = data.map((item) => {
    return {
      id: String(item.ID),
      NazivTvrtke: item.OrgName,
      MjesecGodina: item.virman.Mjesec + " / " + item.virman.Godina,
      Opis: item.virman.Opis,
      StatusPDF: item.ack.DnlPdfAck,
      StatusXML: item.ack.DnlXmlAck,
    };
  });
  const onPageChange = (pageChange) => {
    setPage({ current: pageChange.page, pageSize: pageChange.pageSize });
  };

  const startItem = (page.current - 1) * page.pageSize;
  const endItem = startItem + page.pageSize;
  const displayedRows = filteredData.slice(startItem, endItem);
  return (
    <div style={{ margin: "auto", width: "100%" }}>
      <DataTable
        filterRows={function noRefCheck() {}}
        headers={[
          {
            header: "Naziv tvrtke",
            key: "NazivTvrtke",
          },
          {
            header: "Mjesec / Godina",
            key: "MjesecGodina",
          },
          {
            header: "Opis",
            key: "Opis",
          },
          {
            header: "PDF Preuzet",
            key: "StatusPDF",
          },
          {
            header: "XML Preuzet",
            key: "StatusXML",
          },
        ]}
        isSortable
        locale="hr"
        rows={displayedRows}
        render={({
          rows,
          headers,
          getHeaderProps,
          getRowProps,
          getTableProps,
        }) => (
          <TableContainer style={{ minWidth: "unset" }}>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id} {...getRowProps({ row })}>
                    {row.cells.map((cell) => {
                      if (
                        cell.info.header === "StatusPDF" ||
                        cell.info.header === "StatusXML"
                      ) {
                        return (
                          <TableCell key={cell.id}>
                            {cell.value === false ||
                            cell.value === "waiting" ? (
                              <WarningAltFilled32
                                style={{ width: "100%", height: "100%" }}
                                fill="#FD970F"
                              />
                            ) : (
                              <CheckmarkFilled32
                                style={{ width: "100%", height: "100%" }}
                                fill="#4DA851"
                              />
                            )}
                          </TableCell>
                        );
                      } else {
                        return (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        );
                      }
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      />
      <Pagination
        style={{ overflow: "hidden" }}
        backwardText="Prethodna stranica"
        disabled={false}
        forwardText="Sljedeća stranica"
        isLastPage={false}
        itemRangeText={function noRefCheck() {}}
        itemText={function noRefCheck() {}}
        itemsPerPageText="Broj stavki po stranici:"
        onChange={onPageChange}
        page={1}
        pageNumberText="Page Number"
        pageRangeText={function noRefCheck() {}}
        pageSize={10}
        pageSizes={[10, 20, 30, 40, 50]}
        pageText={function noRefCheck() {}}
        pagesUnknown={false}
        totalItems={filteredData.length}
      />
    </div>
  );
};

export default CheckoutTable;
